import { EventHandler, Browser, closest, isUndefined, isNullOrUndefined, select, detach, getComponent } from '@syncfusion/ej2-base';
import { getRangeIndexes, getRangeFromAddress, getIndexesFromAddress, getRangeAddress, isSingleCell, getCellAddress } from '../../workbook/common/address';
import { keyDown, editOperation, clearCopy, enableToolbarItems, completeAction } from '../common/index';
import { formulaBarOperation, formulaOperation, setActionData, keyUp, getCellPosition, deleteImage, focus, isLockedCells, isNavigationKey } from '../common/index';
import { workbookEditOperation, getFormattedBarText, getFormattedCellObject, wrapEvent, isValidation, activeCellMergedRange, activeCellChanged, getUniqueRange, getSortRange, removeUniquecol, removeSortcol, checkUniqueRange, checkSortRange, reApplyFormula, refreshChart, mergedRange } from '../../workbook/common/event';
import { getSheetName, getSheetIndex, getCell, getColumn, getRowsHeight, getColumnsWidth, checkColumnValidation, setCell } from '../../workbook/base/index';
import { getSheetNameFromAddress, getSheet, selectionComplete, isHiddenRow, isHiddenCol, applyCF, setVisibleMergeIndex, isReadOnlyCells, getTypeFromFormat } from '../../workbook/index';
import { beginAction, updateCell, getAutoDetectFormatParser, isReadOnly, getViewportIndexes, getRow } from '../../workbook/index';
import { hasTemplate, editAlert, getTextWidth, readonlyAlert, finiteAlert } from '../common/index';
import { getSwapRange, getCellIndexes, wrap as wrapText, checkIsFormula, isNumber, isLocked, isCellReference, workbookFormulaOperation } from '../../workbook/index';
import { initiateFormulaReference, initiateCur, clearCellRef, addressHandle, clearRange, dialog, locale } from '../common/index';
import { editValue, initiateEdit, forRefSelRender, isFormulaBarEdit, deleteChart, activeSheetChanged, mouseDown } from '../common/index';
import { checkFormulaRef, getData, clearFormulaDependentCells } from '../../workbook/index';
/**
 * The `Protect-Sheet` module is used to handle the Protecting functionalities in Spreadsheet.
 */
export class Edit {
    /**
     * Constructor for edit module in Spreadsheet.
     *
     * @param {Spreadsheet} parent - Constructor for edit module in Spreadsheet.
     * @private
     */
    constructor(parent) {
        this.editorElem = null;
        this.editCellData = {};
        this.isEdit = false;
        this.isCellEdit = true;
        this.isNewValueEdit = true;
        this.isAltEnter = false;
        this.curEndPos = null;
        this.curStartPos = null;
        this.uniqueColl = '';
        this.uniqueActCell = '';
        this.sortColl = '';
        this.sortActCell = '';
        this.isSpill = false;
        this.keyCodes = {
            BACKSPACE: 8,
            SPACE: 32,
            TAB: 9,
            DELETE: 46,
            ESC: 27,
            ENTER: 13,
            FIRSTALPHABET: 65,
            LASTALPHABET: 90,
            FIRSTNUMBER: 48,
            LASTNUMBER: 59,
            FIRSTNUMPAD: 96,
            LASTNUMPAD: 111,
            SYMBOLSETONESTART: 186,
            SYMBOLSETONEEND: 192,
            SYMBOLSETTWOSTART: 219,
            SYMBOLSETTWOEND: 222,
            FIREFOXEQUALPLUS: 61,
            FIREFOXMINUS: 173,
            F2: 113
        };
        this.formulaErrorStrings = [
            'mismatched parentheses',
            'requires 3 arguments',
            'improper formula',
            'empty expression',
            'mismatched string quotes',
            'wrong number of arguments',
            'invalid arguments'
        ];
        this.parent = parent;
        this.addEventListener();
        //Spreadsheet.Inject(WorkbookEdit);
    }
    /**
     * To destroy the edit module.
     *
     * @returns {void} - To destroy the edit module.
     * @hidden
     */
    destroy() {
        if (this.isEdit) {
            this.cancelEdit(true, false);
        }
        this.removeEventListener();
        this.editorElem = null;
        if (this.formulaErrorStrings) {
            this.formulaErrorStrings = [];
        }
        if (this.editCellData) {
            this.editCellData = {};
        }
        if (this.keyCodes) {
            this.keyCodes = {};
        }
        this.isCellEdit = null;
        this.isAltEnter = null;
        this.isEdit = null;
        this.isNewValueEdit = null;
        this.isSpill = null;
        this.parent = null;
    }
    addEventListener() {
        if (Browser.isDevice && Browser.info.name === 'safari' && (Browser.isIos || Browser.isIos7)) {
            EventHandler.add(this.parent.element, 'touchend', this.tapHandler, this);
        }
        else {
            EventHandler.add(this.parent.element, 'dblclick', this.dblClickHandler, this);
        }
        this.parent.on(mouseDown, this.mouseDownHandler, this);
        this.parent.on(keyUp, this.keyUpHandler, this);
        this.parent.on(keyDown, this.keyDownHandler, this);
        this.parent.on(editOperation, this.performEditOperation, this);
        this.parent.on(initiateCur, this.initiateCurPosition, this);
        this.parent.on(editValue, this.updateFormulaBarValue, this);
        this.parent.on(addressHandle, this.addressHandler, this);
        this.parent.on(initiateEdit, this.initiateRefSelection, this);
        this.parent.on(forRefSelRender, this.refSelectionRender, this);
        this.parent.on(checkUniqueRange, this.checkUniqueRange, this);
        this.parent.on(checkSortRange, this.checkSortRange, this);
        this.parent.on(reApplyFormula, this.reApplyFormula, this);
        this.parent.on(activeSheetChanged, this.sheetChangeHandler, this);
        this.parent.on(readonlyAlert, this.readOnlyAlertHandler, this);
        this.parent.on(finiteAlert, this.finiteAlertHandler, this);
        // IME candidate selection on mobile (e.g. on-screen keyboards)
        EventHandler.add(this.parent.element, 'compositionstart', this.imeCompositionStartHandler, this);
        EventHandler.add(this.parent.element, 'compositionend', this.imeCompositionEndHandler, this);
    }
    removeEventListener() {
        if (Browser.isDevice && Browser.info.name === 'safari' && (Browser.isIos || Browser.isIos7)) {
            EventHandler.remove(this.parent.element, 'touchend', this.tapHandler);
        }
        else {
            EventHandler.remove(this.parent.element, 'dblclick', this.dblClickHandler);
        }
        if (!this.parent.isDestroyed) {
            this.parent.off(mouseDown, this.mouseDownHandler);
            this.parent.off(keyUp, this.keyUpHandler);
            this.parent.off(keyDown, this.keyDownHandler);
            this.parent.off(editOperation, this.performEditOperation);
            this.parent.off(initiateCur, this.initiateCurPosition);
            this.parent.off(editValue, this.updateFormulaBarValue);
            this.parent.off(addressHandle, this.addressHandler);
            this.parent.off(initiateEdit, this.initiateRefSelection);
            this.parent.off(forRefSelRender, this.refSelectionRender);
            this.parent.off(checkUniqueRange, this.checkUniqueRange);
            this.parent.off(checkSortRange, this.checkSortRange);
            this.parent.off(reApplyFormula, this.reApplyFormula);
            this.parent.off(activeSheetChanged, this.sheetChangeHandler);
            this.parent.off(readonlyAlert, this.readOnlyAlertHandler);
            this.parent.off(finiteAlert, this.finiteAlertHandler);
        }
        EventHandler.remove(this.parent.element, 'compositionstart', this.imeCompositionStartHandler);
        EventHandler.remove(this.parent.element, 'compositionend', this.imeCompositionEndHandler);
    }
    getImeEditorTarget(target) {
        const targetEle = target;
        if (!targetEle) {
            return null;
        }
        const formulaBar = this.parent.element.querySelector('.e-formula-bar');
        if (formulaBar && closest(targetEle, '.e-formula-bar')) {
            return formulaBar;
        }
        const editEle = this.getEditElement(this.parent.getActiveSheet());
        if (!editEle) {
            return null;
        }
        const clickedEdit = closest(targetEle, '.e-spreadsheet-edit');
        return clickedEdit && (editEle.contains(clickedEdit) || editEle === clickedEdit) ? editEle : null;
    }
    syncEditModelFromEditor(target) {
        if (!this.parent) {
            return;
        }
        const fromFormulaBar = !!(target && target.classList && target.classList.contains('e-formula-bar'));
        const newValue = fromFormulaBar ? target.value
            : target.textContent;
        if (newValue !== this.editCellData.value) {
            this.refreshEditor(newValue, !fromFormulaBar, fromFormulaBar, false, false);
        }
    }
    imeCompositionStartHandler(e) {
        if (!this.isEdit) {
            return;
        }
        const target = this.getImeEditorTarget(e.target);
        if (target) {
            this.isImeComposing = true;
        }
    }
    imeCompositionEndHandler(e) {
        if (!this.isEdit) {
            return;
        }
        const target = this.getImeEditorTarget(e.target);
        if (!target) {
            return;
        }
        this.isImeComposing = false;
        this.syncEditModelFromEditor(target);
    }
    /**
     * Get the module name.
     *
     * @returns {string} - Get the module name.
     * @private
     */
    getModuleName() {
        return 'edit';
    }
    performEditOperation(args) {
        const action = args.action;
        switch (action) {
            case 'renderEditor':
                this.renderEditor();
                if (args.initLoad && Browser.isDevice && Browser.info.name === 'safari' && (Browser.isIos || Browser.isIos7)) {
                    const focusEditEle = this.parent.createElement('div', { className: 'e-ss-focus-edit', attrs: { 'contentEditable': 'true', 'inputmode': 'none', 'tabindex': '-1' } });
                    const sheetPanel = this.parent.element.querySelector('.e-sheet-panel');
                    if (sheetPanel) {
                        sheetPanel.style.position = 'relative';
                        sheetPanel.appendChild(focusEditEle);
                    }
                    this.parent.element.onfocus = () => {
                        focus(focusEditEle);
                    };
                }
                break;
            case 'refreshEditor':
                this.refreshEditor(args.value, args.refreshFormulaBar, args.refreshEditorElem, args.isAppend, args.trigEvent);
                if (args.refreshCurPos) {
                    this.setCursorPosition();
                }
                break;
            case 'startEdit':
                if (!this.isEdit) {
                    this.isNewValueEdit = args.isNewValueEdit;
                    this.startEdit(args.address, args.value, args.refreshCurPos);
                }
                else {
                    const isEdit = false;
                    const arg = { isEdit: isEdit };
                    this.parent.notify(isFormulaBarEdit, arg);
                    if (arg.isEdit) {
                        this.isNewValueEdit = args.isNewValueEdit;
                        this.startEdit(args.address, args.value, args.refreshCurPos);
                    }
                }
                break;
            case 'endEdit':
                if (this.isEdit) {
                    this.endEdit(args.refreshFormulaBar, null, args.isPublic);
                }
                break;
            case 'cancelEdit':
                if (this.isEdit) {
                    this.cancelEdit(args.refreshFormulaBar);
                }
                break;
            case 'getCurrentEditValue':
                args.editedValue = this.editCellData.value;
                args.editSheetIndex = this.editCellData.sheetIndex;
                if (args.endFormulaRef !== undefined) {
                    args.endFormulaRef = this.endFormulaRef;
                }
                break;
            case 'refreshDependentCellValue':
                this.refreshDependentCellValue(args.rowIdx, args.colIdx);
                break;
            case 'getElement':
                args.element = this.getEditElement(this.parent.getActiveSheet());
                break;
            case 'focusEditorElem':
                this.editorElem.focus();
                break;
            case 'getCurrentEditSheetIdx':
                args.sheetIndex = this.editCellData.sheetIndex;
                break;
        }
    }
    keyUpHandler(e) {
        if (this.isEdit) {
            const editElement = this.getEditElement(this.parent.getActiveSheet());
            if (e.altKey && e.keyCode === 13) {
                if (e.target.classList.contains('e-formula-bar')) {
                    this.positionEditor(true);
                }
                else {
                    editElement.focus();
                    this.altEnter();
                }
                this.isAltEnter = true;
            }
            else if (this.isCellEdit && this.editCellData.value !== editElement.textContent && e.keyCode !== 16 && (!e.shiftKey ||
                (e.shiftKey && !isNavigationKey(e.keyCode)))) {
                this.refreshEditor(editElement.textContent, this.isCellEdit);
            }
            const isFormulaEdit = checkIsFormula(this.editCellData.value, true);
            if (isFormulaEdit && (!e || (e.keyCode !== 16 && e.keyCode !== 17 && (!e.shiftKey || !isNavigationKey(e.keyCode))))) {
                this.updateFormulaReference(editElement);
                if (this.endFormulaRef) {
                    const curOffset = this.getCurPosition();
                    const validCharacters = ['+', '-', '*', '/', this.parent.listSeparator, '(', '=', '&', ':'];
                    if (curOffset.end && validCharacters.indexOf(this.editCellData.value[curOffset.end - 1]) > -1) {
                        this.endFormulaRef = false;
                    }
                }
            }
        }
    }
    updateFormulaReference(editElement) {
        this.removeRefIndicator();
        if (this.editCellData.value !== editElement.textContent) {
            this.refreshEditor(editElement.textContent, true);
        }
        const sheetIdx = this.editCellData.sheetIndex;
        const editValue = this.editCellData.value;
        this.parent.notify(initiateFormulaReference, { range: editValue, formulaSheetIdx: sheetIdx });
    }
    keyDownHandler(e) {
        const trgtElem = e.target;
        const keyCode = e.keyCode;
        const sheet = this.parent.getActiveSheet();
        const actCell = getCellIndexes(sheet.activeCell);
        const cell = getCell(actCell[0], actCell[1], sheet, false, true);
        const isKeyboardShortcut = this.parent.enableKeyboardShortcut;
        if (!closest(trgtElem, '.e-spreadsheet .e-dialog')) {
            if (!sheet.isProtected || trgtElem.classList.contains('e-sheet-rename') || !isLocked(cell, getColumn(sheet, actCell[1])) || ((trgtElem.classList.contains('e-formula-bar') || trgtElem.classList.contains('e-combobox') || trgtElem.classList.contains('e-comment-input')) && !trgtElem.disabled)) {
                if (this.isEdit) {
                    const editorElem = this.getEditElement(sheet);
                    const isFormulaEdit = checkIsFormula(this.editCellData.value, true);
                    if (this.isCellEdit || (isFormulaEdit && this.editCellData.value !== editorElem.textContent && e.keyCode !== 16 &&
                        e.keyCode !== 17)) {
                        if (editorElem && editorElem.style.height !== 'auto') {
                            if (actCell[1] < this.parent.frozenColCount(sheet) && (!sheet.frozenRows || actCell[0] >=
                                this.parent.frozenRowCount(sheet))) {
                                if (getTextWidth(editorElem.textContent, cell.style, this.parent.cellStyle) > parseInt(editorElem.style.maxWidth, 10)) {
                                    editorElem.style.height = 'auto';
                                }
                            }
                            if (getTextWidth(editorElem.textContent, cell.style, this.parent.cellStyle) > parseInt(editorElem.style.maxWidth, 10) - 5) { // 5 decreased for padding.
                                editorElem.style.height = 'auto';
                            }
                        }
                        if (actCell[0] < this.parent.frozenRowCount(sheet) && editorElem && !editorElem.style.overflow && getTextWidth(editorElem.textContent, cell.style, this.parent.cellStyle) > parseInt(editorElem.style.maxWidth, 10)) {
                            editorElem.style.overflow = 'auto';
                        }
                        if (!e.shiftKey || (e.shiftKey && !isNavigationKey(e.keyCode))) {
                            this.refreshEditor(editorElem.textContent, this.isCellEdit, false, false, false);
                        }
                    }
                    if (!e.altKey) {
                        switch (keyCode) {
                            case this.keyCodes.ENTER:
                                if (Browser.isWindows) {
                                    e.preventDefault();
                                }
                                if (!isFormulaEdit) {
                                    this.endEdit(false, e);
                                }
                                else {
                                    this.removeRefIndicator();
                                    if (getSheet(this.parent, this.editCellData.sheetIndex).id === sheet.id) {
                                        this.endEdit(false, e);
                                    }
                                    else {
                                        this.parent.goTo(this.editCellData.fullAddr);
                                        if (this.isEdit) {
                                            this.endEdit(false, e);
                                        }
                                    }
                                }
                                break;
                            case this.keyCodes.TAB:
                                if (!this.hasFormulaSuggSelected()) {
                                    this.endEdit(false, e);
                                }
                                break;
                            case this.keyCodes.ESC:
                                this.cancelEdit(true, true, e);
                                this.removeRefIndicator();
                                break;
                        }
                    }
                }
                else if (trgtElem.classList.contains('e-spreadsheet') || (closest(trgtElem, '.e-sheet-panel') &&
                    !trgtElem.classList.contains('e-comment-input'))) {
                    if (keyCode === 13 && trgtElem.contentEditable === 'true') {
                        e.preventDefault();
                    }
                    const key = String.fromCharCode(keyCode);
                    const isAlphabet = (keyCode >= this.keyCodes.FIRSTALPHABET && keyCode <= this.keyCodes.LASTALPHABET) ||
                        (key.toLowerCase() !== key.toUpperCase() && !(keyCode >= 112 && keyCode <= 123));
                    const isNumeric = (keyCode >= this.keyCodes.FIRSTNUMBER && keyCode <= this.keyCodes.LASTNUMBER);
                    const isNumpadKeys = (keyCode >= this.keyCodes.FIRSTNUMPAD && keyCode <= this.keyCodes.LASTNUMPAD);
                    let isSymbolkeys = (keyCode >= this.keyCodes.SYMBOLSETONESTART &&
                        keyCode <= this.keyCodes.SYMBOLSETONEEND);
                    if (!isSymbolkeys) {
                        isSymbolkeys = (keyCode >= this.keyCodes.SYMBOLSETTWOSTART && keyCode <= this.keyCodes.SYMBOLSETTWOEND);
                    }
                    const isFirefoxExceptionkeys = (keyCode === this.keyCodes.FIREFOXEQUALPLUS) ||
                        (keyCode === this.keyCodes.FIREFOXMINUS);
                    const isF2Edit = (!e.shiftKey && !e.ctrlKey && !e.metaKey && keyCode === this.keyCodes.F2) &&
                        isKeyboardShortcut;
                    const isBackSpace = keyCode === this.keyCodes.BACKSPACE && isKeyboardShortcut;
                    const isMacDelete = /(Macintosh|MacIntel|MacPPC|Mac68K|Mac|Mac OS|iPod|iPad)/i.test(navigator.userAgent) && isBackSpace;
                    const readonlyDialog = this.parent.element.querySelector('.e-readonly-alert-dlg');
                    const overlayElements = this.parent.element.getElementsByClassName('e-ss-overlay-active');
                    if ((!e.ctrlKey && !e.metaKey && !e.altKey && ((!e.shiftKey && keyCode === this.keyCodes.SPACE) || isAlphabet || isNumeric ||
                        isNumpadKeys || isSymbolkeys || (Browser.info.name === 'mozilla' && isFirefoxExceptionkeys))) || isF2Edit || isBackSpace) {
                        if (isF2Edit) {
                            this.isNewValueEdit = false;
                        }
                        if (!readonlyDialog) {
                            if (isReadOnlyCells(this.parent) && overlayElements.length === 0) {
                                this.parent.notify(readonlyAlert, null);
                            }
                            else if (overlayElements.length) {
                                if (isBackSpace && !isMacDelete) {
                                    this.editingHandler('delete');
                                }
                            }
                            else {
                                this.startEdit(null, null, true, true);
                                focus(this.getEditElement(sheet));
                            }
                        }
                    }
                    if ((keyCode === this.keyCodes.DELETE || isMacDelete) && isKeyboardShortcut) {
                        const islockcell = sheet.isProtected && isLockedCells(this.parent);
                        if (!readonlyDialog) {
                            if (islockcell) {
                                this.parent.notify(editAlert, null);
                            }
                            else if (isReadOnlyCells(this.parent) && overlayElements.length === 0) {
                                this.parent.notify(readonlyAlert, null);
                            }
                            else {
                                this.editingHandler('delete');
                                this.parent.notify(activeCellChanged, null);
                            }
                        }
                    }
                }
            }
            else if (((keyCode >= this.keyCodes.FIRSTALPHABET && keyCode <= this.keyCodes.LASTALPHABET) ||
                (keyCode >= this.keyCodes.FIRSTNUMBER && keyCode <= this.keyCodes.LASTNUMBER)
                || (keyCode === this.keyCodes.DELETE) || (keyCode === this.keyCodes.BACKSPACE) || (keyCode === this.keyCodes.SPACE)
                || (keyCode >= this.keyCodes.FIRSTNUMPAD && keyCode <= this.keyCodes.LASTNUMPAD) ||
                (keyCode >= this.keyCodes.SYMBOLSETONESTART && keyCode <= this.keyCodes.SYMBOLSETONEEND)
                || (keyCode >= 219 && keyCode <= 222) || (!e.shiftKey && !e.ctrlKey && !e.metaKey && keyCode === this.keyCodes.F2))
                && (keyCode !== 67) && (keyCode !== 89) && (keyCode !== 90)) {
                if (sheet.protectSettings.insertLink && keyCode === 75) {
                    return;
                }
                if (e.altKey && (keyCode === 65 || keyCode === 70 || keyCode === 72 || keyCode === 77
                    || keyCode === 78 || keyCode === 87)) {
                    return;
                }
                if (!e.ctrlKey && e.keyCode !== 70 && !this.parent.element.querySelector('.e-editAlert-dlg') &&
                    !trgtElem.parentElement.classList.contains('e-unprotectpwd-content') &&
                    !trgtElem.parentElement.classList.contains('e-password-content') &&
                    !trgtElem.parentElement.classList.contains('e-sheet-password-content') &&
                    !trgtElem.parentElement.classList.contains('e-unprotectsheetpwd-content') &&
                    !trgtElem.parentElement.classList.contains('e-reenterpwd-content')) {
                    this.parent.notify(editAlert, null);
                }
            }
        }
    }
    renderEditor() {
        if (!this.editorElem || !select('#' + this.parent.element.id + '_edit', this.parent.element)) {
            const editor = this.parent.createElement('div', { id: this.parent.element.id + '_edit', className: 'e-spreadsheet-edit', attrs: { 'contentEditable': 'true',
                    'role': 'textbox', 'spellcheck': 'false', 'aria-multiline': 'true' } });
            if (this.parent.element.getElementsByClassName('e-spreadsheet-edit')[0]) {
                this.parent.element.getElementsByClassName('e-spreadsheet-edit')[0].remove();
            }
            const sheetContentElem = this.parent.element.querySelector('.e-sheet-content');
            if (!sheetContentElem) {
                return;
            }
            sheetContentElem.appendChild(editor);
            this.editorElem = editor;
        }
        this.parent.notify(formulaOperation, { action: 'renderAutoComplete' });
    }
    refreshEditor(value, refreshFormulaBar, refreshEditorElem, isAppend, trigEvent = true, prevCellValue) {
        if (isAppend) {
            value = this.editCellData.value = this.editCellData.value + value;
        }
        else {
            this.editCellData.value = prevCellValue ? prevCellValue : value;
        }
        const editorElem = this.getEditElement(this.parent.getActiveSheet());
        if (refreshEditorElem && editorElem) {
            editorElem.textContent = value;
        }
        if (refreshFormulaBar) {
            this.parent.notify(formulaBarOperation, { action: 'refreshFormulabar', value: value });
        }
        if (this.parent.isEdit && editorElem && trigEvent && this.editCellData.value === editorElem.textContent) {
            if (this.triggerEvent('cellEditing').cancel) {
                this.cancelEdit(false, false, null, true);
            }
        }
        // if (this.editorElem.scrollHeight + 2 <= this.editCellData.element.offsetHeight) {
        //     this.editorElem.style.height = (this.editCellData.element.offsetHeight + 1) + 'px';
        // } else {
        //     this.editorElem.style.removeProperty('height');
        // }
    }
    startEdit(address, value, refreshCurPos = true, preventFormulaReference) {
        if (this.parent.showSheetTabs) {
            this.parent.element.querySelector('.e-add-sheet-tab').setAttribute('disabled', 'true');
        }
        const sheet = this.parent.getActiveSheet();
        const range = getCellIndexes(sheet.activeCell);
        const cell = getCell(range[0], range[1], sheet, false, true);
        if (this.parent.calculationMode === 'Manual' && checkIsFormula(cell.formula)) {
            this.editCellData.prevFormulaValue = cell.value;
        }
        if (hasTemplate(this.parent, range[0], range[1], this.parent.activeSheetIndex)) {
            const cellEle = this.parent.getCell(range[0], range[1]);
            let isDelTemplate = false;
            const value = cellEle.innerHTML;
            if (cellEle) {
                if (value.indexOf('<') > -1 && value.indexOf('>') > -1 && value.indexOf('input') > -1) {
                    isDelTemplate = true;
                }
            }
            if (isDelTemplate) {
                return;
            }
        }
        const isMergedHiddenCell = this.updateEditCellDetail(address, value);
        this.initiateEditor(refreshCurPos, isMergedHiddenCell);
        this.positionEditor();
        this.parent.isEdit = this.isEdit = true;
        this.parent.notify(clearCopy, null);
        this.parent.notify(enableToolbarItems, [{ enable: false }]);
        if (Browser.isDevice && Browser.info.name === 'safari' && (Browser.isIos || Browser.isIos7)) {
            const editorElem = this.getEditElement(this.parent.getActiveSheet());
            if (editorElem) {
                EventHandler.add(editorElem, 'paste', this.pasteHandler, this);
            }
        }
        if (cell.formula && !preventFormulaReference) {
            this.parent.notify(initiateFormulaReference, { range: cell.formula, formulaSheetIdx: this.editCellData.sheetIndex });
        }
    }
    setCursorPosition() {
        const elem = this.getEditElement(this.parent.getActiveSheet());
        const textLen = elem.textContent.length;
        if (textLen) {
            const selection = document.getSelection();
            const range = document.createRange();
            range.setStart(elem.firstChild, textLen);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        elem.focus();
    }
    hasFormulaSuggSelected() {
        const suggDdlElem = document.getElementById(this.parent.element.id + '_ac_popup');
        return suggDdlElem && suggDdlElem.style.visibility === 'visible' &&
            suggDdlElem.querySelectorAll('.e-item-focus').length > 0;
    }
    editingHandler(action) {
        const pictureElements = document.getElementsByClassName('e-ss-overlay-active');
        const pictureLen = pictureElements.length;
        let isSpill;
        switch (action) {
            case 'delete':
                if (pictureLen > 0) {
                    if (pictureElements[0].classList.contains('e-datavisualization-chart')) {
                        this.parent.notify(deleteChart, {
                            id: pictureElements[0].id, sheetIdx: this.parent.activeSheetIndex + 1
                        });
                    }
                    else {
                        this.parent.notify(deleteImage, {
                            id: pictureElements[0].id, sheetIdx: this.parent.activeSheetIndex + 1
                        });
                    }
                }
                else {
                    const sheet = this.parent.getActiveSheet();
                    let address = sheet.selectedRange;
                    let range = getIndexesFromAddress(address);
                    range = range[0] > range[2] || range[1] > range[3] ? getSwapRange(range) : range;
                    address = getRangeAddress(range);
                    const cellDeleteArgs = { address: sheet.name + '!' + address, cancel: false };
                    this.parent.notify(beginAction, { action: 'cellDelete', eventArgs: cellDeleteArgs });
                    if (cellDeleteArgs.cancel) {
                        return;
                    }
                    address = getRangeFromAddress(cellDeleteArgs.address);
                    range = getRangeIndexes(address);
                    clearRange(this.parent, range, this.parent.activeSheetIndex);
                    this.parent.notify(selectionComplete, {});
                    if (range[0] === 0 && range[1] === 0 && range[2] >= sheet.usedRange.rowIndex && range[3] >= sheet.usedRange.colIndex) {
                        this.parent.setUsedRange(0, 0, sheet, false, true);
                    }
                    const uniqueArgs = { cellIdx: range, isUnique: false };
                    const sortArgs = { cellIdx: range, isSort: false };
                    this.checkUniqueRange(uniqueArgs);
                    this.checkSortRange(sortArgs);
                    if (uniqueArgs.isUnique || sortArgs.isSort) {
                        const indexes = uniqueArgs.isUnique ? getRangeIndexes(this.uniqueColl) : getRangeIndexes(this.sortColl);
                        const cell = getCell(indexes[0], indexes[1], this.parent.getActiveSheet());
                        if (cell && cell.value) {
                            isSpill = cell.value.toString().indexOf('#SPILL!') > -1;
                        }
                    }
                    if ((uniqueArgs.isUnique && this.uniqueColl.split(':')[0] === address.split(':')[0]) ||
                        (sortArgs.isSort && this.sortColl.split(':')[0] === address.split(':')[0])) {
                        const index = getRangeIndexes(this.uniqueColl);
                        for (let i = index[0]; i <= index[2]; i++) {
                            for (let j = index[1]; j <= index[3]; j++) {
                                this.parent.updateCellInfo({ value: '', formula: '' }, getRangeAddress([i, j]), true);
                            }
                        }
                        if (uniqueArgs.isUnique) {
                            this.parent.notify(removeUniquecol, null);
                            this.uniqueColl = '';
                        }
                        if (sortArgs.isSort) {
                            this.parent.notify(removeSortcol, null);
                            this.sortColl = '';
                        }
                    }
                    else if (uniqueArgs.isUnique) {
                        const uniqueRange = getRangeIndexes(this.uniqueColl);
                        if (getCell(uniqueRange[0], uniqueRange[1], sheet).value === '#SPILL!') {
                            let skip = false;
                            for (let j = uniqueRange[0]; j <= uniqueRange[2]; j++) {
                                for (let k = uniqueRange[1]; k <= uniqueRange[3]; k++) {
                                    const cell = getCell(j, k, sheet);
                                    if (j === uniqueRange[0] && k === uniqueRange[1]) {
                                        skip = false;
                                    }
                                    else if (cell && !isNullOrUndefined(cell.value) && cell.value !== '') {
                                        skip = true;
                                    }
                                }
                            }
                            if (!skip) {
                                this.reApplyFormula({ isUnique: true });
                            }
                        }
                    }
                    else if (sortArgs.isSort) {
                        const sortRange = getRangeIndexes(this.sortColl);
                        if (getCell(sortRange[0], sortRange[1], sheet).value === '#SPILL!') {
                            let skip = false;
                            for (let j = sortRange[0]; j <= sortRange[2]; j++) {
                                for (let k = sortRange[1]; k <= sortRange[3]; k++) {
                                    const cell = getCell(j, k, sheet);
                                    if (j === sortRange[0] && k === sortRange[1]) {
                                        skip = false;
                                    }
                                    else if (cell && !isNullOrUndefined(cell.value) && cell.value !== '') {
                                        skip = true;
                                    }
                                }
                            }
                            if (!skip) {
                                this.reApplyFormula({ isSort: true });
                            }
                        }
                    }
                    if (uniqueArgs.isUnique || sortArgs.isSort) {
                        this.parent.notify(completeAction, { action: 'cellDelete',
                            eventArgs: { address: sheet.name + '!' + address, isSpill: isSpill } });
                    }
                    else {
                        this.parent.notify(completeAction, { action: 'cellDelete', eventArgs: { address: sheet.name + '!' + address } });
                    }
                }
                break;
        }
    }
    getCurPosition() {
        const cursorOffset = {};
        const selection = window.getSelection();
        const focusElem = selection && selection.focusNode;
        if (focusElem && focusElem.classList && (focusElem.classList.contains('e-formula-bar-panel') || focusElem.classList.contains('e-formula-bar'))) {
            const formulaBar = focusElem.classList.contains('e-formula-bar')
                ? focusElem
                : focusElem.getElementsByClassName('e-formula-bar e-css')[0];
            if (formulaBar.value === this.editCellData.value) {
                cursorOffset.start = formulaBar.selectionStart;
                cursorOffset.end = formulaBar.selectionEnd;
            }
        }
        else if (this.getEditElement(this.parent.getActiveSheet()).textContent === this.editCellData.value) {
            cursorOffset.start = selection.anchorOffset;
            cursorOffset.end = selection.focusOffset;
            if (cursorOffset.start > cursorOffset.end) {
                const x = cursorOffset.start;
                cursorOffset.start = cursorOffset.end;
                cursorOffset.end = x;
            }
        }
        return cursorOffset;
    }
    mouseDownHandler(e) {
        if (!closest(e.target, '.e-findtool-dlg') && !closest(e.target, '.e-validation-error-dlg')) {
            if (this.isEdit) {
                const curOffset = this.getCurPosition();
                let selectionStart;
                let selectionEnd;
                if (curOffset.start) {
                    this.curStartPos = selectionStart = curOffset.start;
                }
                if (curOffset.end) {
                    this.curEndPos = selectionEnd = curOffset.end;
                }
                const trgtElem = e.target;
                const sheet = this.parent.getActiveSheet();
                const formulaRefIndicator = this.parent.element.querySelector('.e-formularef-indicator');
                this.isCellEdit = trgtElem.classList.contains('e-spreadsheet-edit');
                let isFormula = checkIsFormula(this.editCellData.value, true);
                const editorElem = this.getEditElement(sheet);
                const validCharacters = ['+', '-', '*', '/', this.parent.listSeparator, '(', '=', '&', ':'];
                if (trgtElem.classList.contains('e-cell') || trgtElem.classList.contains('e-header-cell') ||
                    trgtElem.classList.contains('e-selectall') || closest(trgtElem, '.e-toolbar-item.e-active') || closest(trgtElem, '.e-table')) {
                    if (!isFormula || this.endFormulaRef) {
                        this.endFormulaRef = false;
                        this.endEdit(false, e);
                    }
                    else {
                        const actCellIdx = getCellIndexes(sheet.activeCell);
                        const cell = getCell(actCellIdx[0], actCellIdx[1], sheet);
                        const editorValue = document.activeElement.classList.contains('e-formula-bar') ?
                            document.activeElement.value : editorElem.textContent;
                        if (this.editCellData.value === editorValue) {
                            if (selectionStart === selectionEnd) {
                                if (this.editCellData.sheetIndex !== getSheetIndex(this.parent, sheet.name)) {
                                    if (validCharacters.indexOf(editorValue.substring(selectionStart - 1, selectionStart)) === -1) {
                                        if (formulaRefIndicator) {
                                            formulaRefIndicator.parentElement.removeChild(formulaRefIndicator);
                                        }
                                        this.parent.goTo(this.editCellData.fullAddr);
                                        this.endEdit(false, e);
                                        return;
                                    }
                                }
                                else if (validCharacters.indexOf(editorElem.textContent.substring(selectionStart - 1, selectionStart)) === -1) {
                                    if (formulaRefIndicator) {
                                        formulaRefIndicator.parentElement.removeChild(formulaRefIndicator);
                                    }
                                    this.endEdit(false, e);
                                    return;
                                }
                            }
                            else if (validCharacters.indexOf(editorValue.substring(selectionStart - 1, selectionStart)) !== -1 &&
                                isCellReference(editorValue.substring(selectionStart, selectionEnd)) &&
                                editorValue.indexOf(':') !== selectionEnd) {
                                this.editCellData.value = editorValue.substring(0, selectionStart) +
                                    editorValue.substring(selectionEnd, editorValue.length);
                            }
                        }
                        if (!cell) {
                            return;
                        }
                        isFormula = cell.formula && (checkIsFormula(cell.formula) || (this.editCellData.value &&
                            this.editCellData.value.toString().indexOf('=') === 0));
                        if (isFormula && this.parent.isEdit) {
                            const curPos = selectionEnd;
                            if (this.editCellData.value.length === curPos) {
                                if (this.editCellData.value.substring(this.editCellData.value.length - 1) === ')' ||
                                    isNumber(this.editCellData.value.substring(this.editCellData.value.length - 1))) {
                                    if (formulaRefIndicator) {
                                        formulaRefIndicator.parentElement.removeChild(formulaRefIndicator);
                                    }
                                    this.endEdit(false, e);
                                }
                            }
                            else if (this.editCellData.value === editorValue &&
                                validCharacters.indexOf(editorValue.substring(curPos - 1, curPos)) === -1) {
                                if (formulaRefIndicator) {
                                    formulaRefIndicator.parentElement.removeChild(formulaRefIndicator);
                                }
                                this.endEdit(false, e);
                            }
                        }
                    }
                }
                else {
                    if (isFormula && this.editCellData.value === editorElem.textContent && editorElem.textContent.indexOf('(') !==
                        editorElem.textContent.length - 1 && !this.isCellEdit && !trgtElem.classList.contains('e-formula-bar') &&
                        validCharacters.indexOf(this.editCellData.value.substring(selectionStart - 1, selectionStart)) === -1) {
                        if (getSheet(this.parent, this.editCellData.sheetIndex).id === sheet.id) {
                            const curPos = window.getSelection().focusOffset;
                            if (validCharacters.indexOf(editorElem.textContent.substring(curPos - 1, curPos)) === -1) {
                                if (formulaRefIndicator) {
                                    formulaRefIndicator.parentElement.removeChild(formulaRefIndicator);
                                }
                                this.parent.goTo(this.editCellData.fullAddr);
                                if (this.isEdit) {
                                    this.endEdit(false, e);
                                }
                                return;
                            }
                        }
                    }
                }
            }
        }
    }
    pasteHandler(e) {
        const target = e.target;
        setTimeout(() => {
            if (!this.isEdit) {
                return;
            }
            const editorEle = target.parentElement && closest(target, '.e-spreadsheet-edit');
            if (editorEle) {
                this.syncEditModelFromEditor(editorEle);
            }
        }, 0);
    }
    tapHandler(e) {
        if (!this.tapedTwice) {
            this.tapedTwice = true;
            setTimeout(() => {
                this.tapedTwice = false;
                if (!this.parent.isEdit && e.target.classList.contains('e-cell')) {
                    const focusEditEle = this.parent.element.querySelector('.e-ss-focus-edit');
                    if (focusEditEle) {
                        focus(focusEditEle);
                    }
                }
            }, 300);
            return;
        }
        e.preventDefault();
        this.dblClickHandler(e);
    }
    dblClickHandler(e) {
        const trgt = e.target;
        if (!closest(trgt, '.e-datavisualization-chart') && !trgt.classList.contains('e-ss-overlay') &&
            (trgt.classList.contains('e-active-cell') || trgt.classList.contains('e-cell') || trgt.classList.contains('e-wrap-content') ||
                closest(trgt, '.e-sheet-content') || trgt.classList.contains('e-table'))) {
            const sheet = this.parent.getActiveSheet();
            const actCell = getCellIndexes(sheet.activeCell);
            const cell = getCell(actCell[0], actCell[1], sheet, false, true);
            if (isReadOnly(cell, getColumn(sheet, actCell[1]), getRow(sheet, actCell[0]))) {
                this.parent.notify(readonlyAlert, null);
            }
            else if (!sheet.isProtected || !isLocked(cell, getColumn(sheet, actCell[1]))) {
                if (this.isEdit) {
                    if (!trgt.classList.contains('e-spreadsheet-edit')) {
                        if (checkIsFormula(this.editCellData.value)) {
                            const sheetName = this.editCellData.fullAddr.substring(0, this.editCellData.fullAddr.lastIndexOf('!'));
                            if (this.parent.getActiveSheet().name === sheetName) {
                                this.endEdit();
                                this.removeRefIndicator();
                            }
                        }
                        else {
                            this.endEdit();
                            this.removeRefIndicator();
                        }
                    }
                }
                else {
                    this.isNewValueEdit = false;
                    this.startEdit();
                    focus(this.getEditElement(sheet));
                }
            }
            else {
                this.parent.notify(editAlert, null);
            }
        }
    }
    updateEditCellDetail(addr, value) {
        let sheetIdx;
        let sheet;
        let isMergedHiddenCell;
        if (isNullOrUndefined(this.editCellData.sheetIndex)) {
            if (addr && addr.lastIndexOf('!') > -1) {
                sheetIdx = getSheetIndex(this.parent, getSheetNameFromAddress(addr));
            }
            else {
                sheetIdx = this.parent.activeSheetIndex;
            }
        }
        else {
            sheetIdx = this.editCellData.sheetIndex;
        }
        if (!this.editCellData.addr) {
            sheet = getSheet(this.parent, sheetIdx);
            if (addr) {
                addr = getRangeFromAddress(addr);
            }
            else {
                addr = sheet.activeCell;
            }
        }
        else if (checkIsFormula(this.editCellData.value, true)) {
            sheet = getSheet(this.parent, sheetIdx);
            this.isNewValueEdit = false;
        }
        if (addr) {
            const range = getRangeIndexes(addr);
            let rowIdx = range[0];
            let colIdx = range[1];
            const model = getCell(rowIdx, colIdx, sheet, false, true);
            if (model.colSpan > 1 || model.rowSpan > 1) {
                const mergeArgs = { sheet: sheet, cell: model, rowIdx: rowIdx, colIdx: colIdx };
                setVisibleMergeIndex(mergeArgs);
                rowIdx = mergeArgs.rowIdx;
                colIdx = mergeArgs.colIdx;
                isMergedHiddenCell = mergeArgs.isMergedHiddenCell;
            }
            const cellElem = this.parent.getCell(rowIdx, colIdx);
            const cellPosition = getCellPosition(sheet, range, this.parent.frozenRowCount(sheet), this.parent.frozenColCount(sheet), this.parent.viewport.beforeFreezeHeight, this.parent.viewport.beforeFreezeWidth, this.parent.sheetModule.colGroupWidth);
            this.editCellData = {
                addr: addr,
                fullAddr: getSheetName(this.parent, sheetIdx) + '!' + addr,
                rowIndex: rowIdx,
                colIndex: colIdx,
                sheetIndex: sheetIdx,
                element: cellElem,
                value: value || '',
                position: cellPosition,
                prevFormulaValue: this.editCellData.prevFormulaValue
            };
        }
        return isMergedHiddenCell;
    }
    initiateEditor(refreshCurPos, isMergedHiddenCell) {
        getData(this.parent, this.editCellData.fullAddr, false, isMergedHiddenCell).then((values) => {
            if (!this.parent) {
                return;
            }
            values.forEach((cell) => {
                let value;
                const updateEditValue = () => {
                    const args = { cell: cell, value: cell ? cell.value : '',
                        showFormattedText: this.editCellData.showFormattedText };
                    this.parent.notify(getFormattedBarText, args);
                    value = cell ? (cell.formula || args.value) : '';
                    this.editCellData.oldValue = value;
                };
                updateEditValue();
                const evtArgs = this.triggerEvent('cellEdit', null, value);
                if (evtArgs.cancel) {
                    this.cancelEdit(true, false, null, true);
                    return;
                }
                if (evtArgs.showFormattedText) {
                    // For SF-354174 ticket we have provided 'dd/MM/yyyy' support and diplayed the formatted value in the editor which is
                    // not a default behavior. To handle this, we have added this property and it applies only for the 'dd/MM/yyyy' format.
                    this.editCellData.showFormattedText = true;
                    updateEditValue();
                }
                if (this.editCellData.value) {
                    value = this.editCellData.value;
                }
                else {
                    this.editCellData.value = value;
                }
                let prevCellValue;
                if (this.isNewValueEdit) {
                    prevCellValue = value;
                    value = '';
                }
                else {
                    this.isNewValueEdit = true;
                }
                if (isUndefined(value)) {
                    value = '';
                }
                this.refreshEditor(value, false, true, false, false, prevCellValue);
                if (refreshCurPos) {
                    this.setCursorPosition();
                }
            });
        });
    }
    positionEditor(isWrap) {
        let tdElem = this.editCellData.element;
        const isEdit = false;
        let cellEle;
        const arg = { isEdit: isEdit };
        this.parent.notify(isFormulaBarEdit, arg);
        if (arg.isEdit && isNullOrUndefined(tdElem)) {
            cellEle = this.parent.getCell(this.editCellData.rowIndex, this.editCellData.colIndex);
            tdElem = cellEle;
            this.editCellData.element = cellEle;
        }
        if (tdElem) {
            tdElem.classList.add('e-ss-edited');
            const sheet = this.parent.getActiveSheet();
            const cell = getCell(this.editCellData.rowIndex, this.editCellData.colIndex, sheet, false, true);
            const left = this.editCellData.position.left + 1;
            const top = this.editCellData.position.top + 1;
            const args = { range: [this.editCellData.rowIndex, this.editCellData.colIndex, this.editCellData.rowIndex,
                    this.editCellData.colIndex] };
            this.parent.notify(activeCellMergedRange, args);
            const minHeight = getRowsHeight(sheet, args.range[0], args.range[2]) - 3;
            const minWidth = getColumnsWidth(sheet, args.range[1], args.range[3]) - 3;
            const cont = this.parent.getMainContent();
            const mainContElement = cont.parentElement;
            let editWidth;
            const frozenCol = this.parent.frozenColCount(sheet);
            let zIndex;
            let preventWrap;
            const frozenRow = this.parent.frozenRowCount(sheet);
            let addWrap;
            if (this.editCellData.colIndex < frozenCol) {
                editWidth = Math.abs(this.parent.getRowHeaderContent().getBoundingClientRect()[this.parent.enableRtl ? 'left' : 'right'] -
                    tdElem.getBoundingClientRect()[this.parent.enableRtl ? 'right' : 'left']) - 1;
                if (this.editCellData.rowIndex < frozenRow) {
                    if (this.parent.getRowHeaderContent().style.zIndex === '2') {
                        zIndex = '3';
                    }
                }
                else {
                    if (getTextWidth(cell.value, cell.style, this.parent.cellStyle) > editWidth) {
                        addWrap = true;
                    }
                }
            }
            else {
                editWidth = (mainContElement.offsetWidth - (left - cont.scrollLeft) - 28) -
                    this.parent.sheetModule.getRowHeaderWidth(sheet);
                if (Browser.info.name !== 'safari') {
                    const tdEleInf = tdElem.getBoundingClientRect();
                    const verticalScrollBarWidth = this.parent.sheetModule.getScrollSize();
                    const horizontalScrollBar = this.parent.getScrollElement();
                    const visibleScrollWidth = horizontalScrollBar ?
                        (horizontalScrollBar.getBoundingClientRect().width - verticalScrollBarWidth) : 0;
                    if (horizontalScrollBar && tdEleInf.width < visibleScrollWidth) {
                        const mainContEleRect = mainContElement.getBoundingClientRect();
                        if (this.parent.enableRtl) {
                            if ((mainContEleRect.left + verticalScrollBarWidth) > tdEleInf.left) {
                                horizontalScrollBar.scrollLeft -= tdEleInf.width;
                            }
                        }
                        else {
                            if ((mainContEleRect.right - verticalScrollBarWidth) < tdEleInf.right) {
                                horizontalScrollBar.scrollLeft += (tdEleInf.width - editWidth);
                            }
                        }
                    }
                }
            }
            if (this.editCellData.rowIndex < frozenRow) {
                preventWrap = true;
            }
            const height = !preventWrap && ((cell && cell.wrap) || (tdElem && isWrap) || addWrap) ? 'auto;' : minHeight + 'px;';
            // let editHeight: number = mainContElement.offsetHeight - top - 28;
            let inlineStyles = 'display:block;top:' + top + 'px;' + (this.parent.enableRtl ? 'right:' : 'left:') + left + 'px;' +
                'min-width:' + minWidth + 'px;max-width:' + (cell && cell.wrap ? minWidth : editWidth) + 'px;' +
                'height:' + height + (cell && cell.wrap ? ('width:' + minWidth + 'px;') : '') + 'min-height:' + minHeight + 'px;' +
                (zIndex ? 'z-index: ' + zIndex + ';' : '') + (preventWrap && ((cell && !cell.wrap) || (tdElem && isWrap)) && (getTextWidth(cell.value, cell.style, this.parent.cellStyle) > editWidth || (tdElem && isWrap)) ? 'overflow: auto;' : '');
            const styles = tdElem.style.cssText.split(';');
            styles.forEach((style) => {
                if (!style.includes('border')) {
                    inlineStyles += style + ';';
                }
            });
            const editorElem = this.getEditElement(sheet, true);
            editorElem.style.cssText = inlineStyles;
            if (getTextWidth(editorElem.textContent, cell.style, this.parent.cellStyle) > editWidth) {
                editorElem.style.height = 'auto';
            }
            // we using edit div height as auto , while editing div enlarges and hide active cell bottom border for that
            // we increasing 1px height to active cell.
            const actCell = this.parent.element.querySelector('.e-active-cell');
            if (actCell) {
                actCell.style.height = (minHeight + 4) + 'px';
            }
            if (tdElem.classList.contains('e-right-align')) {
                editorElem.classList.add('e-right-align');
            }
            else if (tdElem.classList.contains('e-center-align')) {
                editorElem.classList.add('e-center-align');
            }
        }
    }
    updateEditedValue(tdRefresh, value, e, isPublic) {
        const oldCellValue = this.editCellData.oldValue;
        if (value) {
            this.editCellData.value = value;
        }
        if (this.parent.isEdit && this.editCellData.value && !isNumber(this.editCellData.value)) {
            const firstChar = this.editCellData.value[0];
            if (firstChar === '+' || firstChar === '-') {
                const valuePart = this.editCellData.value.substring(1).trim();
                if (valuePart) {
                    const parseCell = { value: this.editCellData.value };
                    getAutoDetectFormatParser(this.parent)(parseCell);
                    if (!isNumber(parseCell.value)) {
                        this.editCellData.value = '=' + firstChar + valuePart;
                    }
                }
            }
        }
        const newVal = this.editCellData.value;
        /* To set the before cell details for undo redo. */
        this.parent.notify(setActionData, { args: { action: 'beforeCellSave', eventArgs: { address: this.editCellData.addr } } });
        let isValidCellValue = true;
        if (this.parent.allowDataValidation) {
            const sheet = this.parent.getActiveSheet();
            const cellIndex = getRangeIndexes(sheet.activeCell);
            const cell = getCell(cellIndex[0], cellIndex[1], sheet, false, true);
            const column = getColumn(sheet, cellIndex[1]);
            if (cell.validation || checkColumnValidation(column, cellIndex[0], cellIndex[1])) {
                const editedValue = this.editCellData.value || this.getEditElement(sheet).innerText;
                const sheetIdx = this.parent.activeSheetIndex;
                const range = typeof this.editCellData.addr === 'string' ? getRangeIndexes(this.editCellData.addr) :
                    this.editCellData.addr;
                const validEventArgs = { value: editedValue, range, sheetIdx, isEdit: true, td: null, isValid: true };
                const currEditedCell = Object.assign({}, cell, { value: editedValue }); // Update edited value for validation purpose.
                setCell(cellIndex[0], cellIndex[1], sheet, currEditedCell);
                this.parent.notify(isValidation, validEventArgs);
                setCell(cellIndex[0], cellIndex[1], sheet, cell);
                isValidCellValue = validEventArgs.isValid;
                if (isValidCellValue) {
                    if (checkIsFormula(editedValue) || !cell.format) {
                        if (!this.editCellData.value) {
                            this.editCellData.value = editedValue;
                        }
                    }
                    else if (editedValue !== validEventArgs.value || (!this.editCellData.value && validEventArgs.value)) {
                        this.editCellData.value = validEventArgs.value;
                    }
                }
                else {
                    this.isCellEdit = true;
                }
            }
        }
        if (!isPublic && checkIsFormula(this.editCellData.value)) {
            const eventArgs = { formula: this.editCellData.value };
            this.parent.notify(checkFormulaRef, eventArgs);
            if (eventArgs.isInvalid) {
                let isYesBtnClick;
                this.isCellEdit = true;
                isValidCellValue = false;
                const l10n = this.parent.serviceLocator.getService(locale);
                const erroDialogInst = this.parent.serviceLocator.getService(dialog);
                erroDialogInst.show({
                    width: 400, isModal: true, showCloseIcon: true, target: this.parent.element, cssClass: 'e-validation-error-dlg',
                    content: `${l10n.getConstant('CellReferenceTypoError')}<br>${eventArgs.formula}`,
                    beforeOpen: () => this.editCellData.element.focus(),
                    buttons: [{
                            buttonModel: { content: l10n.getConstant('Yes'), isPrimary: true },
                            click: () => {
                                isYesBtnClick = true;
                                erroDialogInst.hide();
                            }
                        },
                        {
                            buttonModel: { content: l10n.getConstant('No') },
                            click: () => erroDialogInst.hide()
                        }],
                    close: () => {
                        if (isYesBtnClick) {
                            value = this.editCellData.value = eventArgs.formula;
                            this.updateCell(oldCellValue, tdRefresh, value, newVal, e);
                            this.parent.notify(formulaBarOperation, { action: 'refreshFormulabar', value: eventArgs.formula });
                        }
                        else {
                            const editorElem = this.getEditElement(this.parent.getActiveSheet());
                            if (editorElem.innerText) {
                                window.getSelection().selectAllChildren(editorElem);
                            }
                        }
                    }
                }, false);
            }
        }
        if (isValidCellValue) {
            this.updateCell(oldCellValue, tdRefresh, value, newVal, e);
        }
        else if (e) {
            e.preventDefault();
        }
    }
    updateCell(oldCellValue, tdRefresh, value, newVal, e) {
        const oldValue = oldCellValue ? oldCellValue.toString().toUpperCase() : '';
        const sheet = this.parent.getActiveSheet();
        if (oldCellValue || oldCellValue === 0) {
            oldCellValue = oldCellValue.toString();
        }
        let curCellValue = this.editCellData.value;
        if (curCellValue) {
            curCellValue = curCellValue.toString();
        }
        const isCellValChanged = oldCellValue !== curCellValue || checkIsFormula(oldValue);
        if (isCellValChanged) {
            if (this.isAltEnter && curCellValue && curCellValue.includes('\n')) {
                wrapText(sheet.activeCell, true, this.parent, true);
                this.refreshEditor(curCellValue, this.isCellEdit, false, false, false);
            }
            const cellIndex = getRangeIndexes(sheet.activeCell);
            if (oldCellValue && this.editCellData.value === '') {
                if (oldCellValue.indexOf('=UNIQUE(') > -1) {
                    this.parent.notify(removeUniquecol, null);
                }
                else if (oldCellValue.indexOf('=SORT(') > -1) {
                    this.parent.notify(removeSortcol, null);
                }
            }
            const args = { cellIdx: cellIndex, isUnique: false };
            this.checkUniqueRange(args);
            const sortArgs = { cellIdx: cellIndex, isSort: false };
            this.checkSortRange(sortArgs);
            const isUniqueRange = args.isUnique;
            const isSortRange = sortArgs.isSort;
            if ((isUniqueRange || isSortRange) && oldCellValue !== '' && this.editCellData.value === '') {
                const rangeIdx = getRangeIndexes(isUniqueRange ? this.uniqueColl : this.sortColl);
                const cellValue = getCell(rangeIdx[0], rangeIdx[1], sheet).value.toString();
                if (!cellValue.includes('#SPILL!')) {
                    return;
                }
            }
            if (isUniqueRange && oldCellValue && oldCellValue.toString().includes('UNIQUE') &&
                this.editCellData.value && this.editCellData.value.toString().includes('UNIQUE')) {
                this.updateUniqueRange('');
            }
            if (isSortRange && oldCellValue && oldCellValue.toString().includes('SORT') &&
                this.editCellData.value && this.editCellData.value.toString().includes('SORT')) {
                this.updateSortRange('');
            }
            const evtArgs = {
                action: 'updateCellValue',
                address: this.editCellData.addr, value: this.editCellData.value, skipCellFormat: this.editCellData.showFormattedText
            };
            this.parent.notify(workbookEditOperation, evtArgs);
            const updatedCell = getCell(cellIndex[0], cellIndex[1], sheet, true);
            let cellValue;
            if (!isNullOrUndefined(updatedCell) && !isNullOrUndefined(updatedCell.value)) {
                cellValue = updatedCell.value.toString();
            }
            const isCircularRefError = cellValue === '#CIRCULARREF!';
            const isInvalidFormula = this.formulaErrorStrings.indexOf(cellValue) > -1;
            if (isInvalidFormula || isCircularRefError) {
                let isDlgOpenCancel;
                if (e) {
                    const target = e.target;
                    const ribbonCls = ['e-toolbar-item', 'e-tab-wrap', 'e-text-wrap', 'e-tab-text', 'e-caret'];
                    const skipAlertCls = ['e-scroller', 'e-main-panel', 'e-autofill'];
                    if ((!ribbonCls.some((cls) => target.classList.contains(cls)) || !closest(target, '.e-ribbon')) &&
                        !skipAlertCls.some((cls) => target.classList.contains(cls))) {
                        isDlgOpenCancel = this.showFormulaAlertDlg(cellValue, isCircularRefError);
                    }
                    if (!isDlgOpenCancel) {
                        e.preventDefault();
                    }
                }
                if (!isDlgOpenCancel) {
                    delete updatedCell.value;
                    delete updatedCell.formula;
                    this.parent.notify(clearFormulaDependentCells, { cellRef: sheet.activeCell, clearFormulaInfo: true });
                    if (checkIsFormula(oldValue)) {
                        this.parent.updateCellInfo({ formula: oldValue }, sheet.activeCell);
                    }
                    else if (oldCellValue) {
                        this.parent.updateCellInfo({ value: oldCellValue }, sheet.activeCell);
                    }
                    return;
                }
                else {
                    updatedCell.value = '0';
                }
            }
            let indexes;
            if (evtArgs.isFormulaDependent) {
                indexes = getViewportIndexes(this.parent, this.parent.viewport);
            }
            const cell = getCell(cellIndex[0], cellIndex[1], sheet, true);
            const eventArgs = this.getRefreshNodeArgs(cell, this.editCellData.element, this.editCellData.rowIndex, this.editCellData.colIndex);
            this.editCellData.value = eventArgs.value;
            this.parent.notify(refreshChart, { cell: null, rIdx: this.editCellData.rowIndex, cIdx: this.editCellData.colIndex, viewportIndexes: indexes });
            if (cell && cell.formula) {
                this.editCellData.formula = cell.formula;
            }
            if (tdRefresh) {
                this.parent.refreshNode(this.editCellData.element, eventArgs);
            }
            if (cell && cell.hyperlink) {
                this.parent.serviceLocator.getService('cell').refreshRange(cellIndex);
            }
            if (sheet.conditionalFormats && sheet.conditionalFormats.length) {
                this.parent.notify(applyCF, {
                    indexes: [this.editCellData.rowIndex, this.editCellData.colIndex], isAction: true,
                    refreshAll: evtArgs.isFormulaDependent, isEdit: true
                });
            }
            if (cell && cell.wrap) {
                this.parent.notify(wrapEvent, { range: cellIndex, wrap: true, sheet: sheet });
            }
            if (isUniqueRange || isSortRange) {
                let rangeIdx = [];
                if (isUniqueRange) {
                    rangeIdx = getRangeIndexes(this.uniqueColl);
                }
                if (isSortRange) {
                    rangeIdx = getRangeIndexes(this.sortColl);
                }
                if (getCell(rangeIdx[0], rangeIdx[1], sheet).value.toString().indexOf('#SPILL!') > -1) {
                    this.isSpill = true;
                }
                if ((oldCellValue !== '' && this.editCellData.value === '') ||
                    (this.editCellData.formula && this.editCellData.formula.length > 1 &&
                        oldCellValue !== this.editCellData.formula)) {
                    let skip = false;
                    for (let j = rangeIdx[0]; j <= rangeIdx[2]; j++) {
                        for (let k = rangeIdx[1]; k <= rangeIdx[3]; k++) {
                            const cell = getCell(j, k, sheet);
                            if (j === rangeIdx[0] && k === rangeIdx[1]) {
                                skip = false;
                            }
                            else if (cell && !isNullOrUndefined(cell.value) && cell.value !== '') {
                                skip = true;
                            }
                        }
                    }
                    if (!skip) {
                        if (isUniqueRange) {
                            this.reApplyFormula({ isUnique: true });
                        }
                        if (isSortRange) {
                            this.reApplyFormula({ isSort: true });
                        }
                    }
                }
                else {
                    if (isUniqueRange) {
                        this.updateUniqueRange(newVal);
                    }
                    if (isSortRange) {
                        this.updateSortRange(newVal);
                    }
                }
            }
        }
        else {
            if (this.editCellData.value && this.editCellData.value.toString().includes('\n')) {
                const cell = getCell(this.editCellData.rowIndex, this.editCellData.colIndex, sheet, false, true);
                if (cell && !cell.wrap) {
                    wrapText(sheet.activeCell, true, this.parent, true);
                }
            }
        }
        this.triggerEvent('cellSave', e, value);
        this.resetEditState();
        this.focusElement(e);
    }
    checkUniqueorSortRange(args, eventKey) {
        const rangeArgs = { range: [] };
        this.parent.notify(eventKey, rangeArgs);
        const collection = rangeArgs.range;
        const sheetName = args.sheetName || this.parent.getActiveSheet().name;
        const isUnique = args.isUnique !== undefined;
        for (let i = 0; i < collection.length; i++) {
            const address = collection[i];
            const colSheet = address.substring(0, address.lastIndexOf('!'));
            if (colSheet !== sheetName) {
                continue;
            }
            const rangeIdx = getRangeIndexes(address);
            for (let rowIdx = rangeIdx[0]; rowIdx <= rangeIdx[2]; rowIdx++) {
                for (let colIdx = rangeIdx[1]; colIdx <= rangeIdx[3]; colIdx++) {
                    if (args.cellIdx[0] === rowIdx && args.cellIdx[1] === colIdx) {
                        if (isUnique) {
                            args.isUnique = true;
                            this.uniqueCell = true;
                            const prevIndex = this.uniqueColl !== '' ? getRangeIndexes(this.uniqueColl) : [0, 0, 0, 0];
                            const collectionIndex = rangeIdx;
                            if (prevIndex[0] === collectionIndex[0] && prevIndex[1] === collectionIndex[1]) {
                                const merged = [prevIndex[0], collectionIndex[1],
                                    prevIndex[2] > collectionIndex[2] ? prevIndex[2] : collectionIndex[2],
                                    prevIndex[3] > collectionIndex[3] ? prevIndex[3] : collectionIndex[3]];
                                this.uniqueColl = getRangeAddress(merged);
                                args.uniqueRange = this.uniqueColl;
                            }
                            else {
                                this.uniqueColl = address;
                                args.uniqueRange = address;
                            }
                        }
                        else {
                            args.isSort = true;
                            this.sortCell = true;
                            const prevIndex = this.sortColl !== '' ? getRangeIndexes(this.sortColl) : [0, 0, 0, 0];
                            const collectionIndex = rangeIdx;
                            if (prevIndex[0] === collectionIndex[0] && prevIndex[1] === collectionIndex[1]) {
                                const merged = [
                                    prevIndex[0], collectionIndex[1],
                                    prevIndex[2] > collectionIndex[2] ? prevIndex[2] : collectionIndex[2],
                                    prevIndex[3] > collectionIndex[3] ? prevIndex[3] : collectionIndex[3]
                                ];
                                this.sortColl = getRangeAddress(merged);
                                args.sortRange = this.sortColl;
                            }
                            else {
                                this.sortColl = address;
                                args.sortRange = address;
                            }
                        }
                    }
                }
            }
        }
    }
    checkUniqueRange(uniquArgs) {
        this.checkUniqueorSortRange(uniquArgs, getUniqueRange);
    }
    checkSortRange(sortArgs) {
        this.checkUniqueorSortRange(sortArgs, getSortRange);
    }
    updateUniqueRange(value) {
        const rangeIdx = getRangeIndexes(this.uniqueColl);
        let skip = false;
        if (getCell(rangeIdx[0], rangeIdx[1], this.parent.getActiveSheet()).value !== '#SPILL!') {
            skip = true;
        }
        for (let j = rangeIdx[0]; j <= rangeIdx[2]; j++) {
            for (let k = rangeIdx[1]; k <= rangeIdx[3]; k++) {
                if (skip) {
                    if (j === rangeIdx[0] && k === rangeIdx[1]) {
                        this.parent.updateCellInfo({ value: '#SPILL!' }, getRangeAddress([j, k]), true);
                    }
                    else {
                        if (getRangeAddress([j, k]).split(':')[0] === this.editCellData.addr) {
                            this.parent.updateCellInfo({ value: value }, getRangeAddress([j, k]), true);
                        }
                        else {
                            this.parent.updateCellInfo({ value: '' }, getRangeAddress([j, k]), true);
                        }
                    }
                }
            }
        }
    }
    updateSortRange(value) {
        const rangeIdx = getRangeIndexes(this.sortColl);
        let skip = false;
        if (getCell(rangeIdx[0], rangeIdx[1], this.parent.getActiveSheet()).value !== '#SPILL!') {
            skip = true;
        }
        for (let j = rangeIdx[0]; j <= rangeIdx[2]; j++) {
            for (let k = rangeIdx[1]; k <= rangeIdx[3]; k++) {
                if (skip) {
                    if (j === rangeIdx[0] && k === rangeIdx[1]) {
                        this.parent.updateCellInfo({ value: '#SPILL!' }, getRangeAddress([j, k]), true);
                    }
                    else {
                        if (getRangeAddress([j, k]).split(':')[0] === this.editCellData.addr) {
                            this.parent.updateCellInfo({ value: value }, getRangeAddress([j, k]), true);
                        }
                        else {
                            this.parent.updateCellInfo({ value: '' }, getRangeAddress([j, k]), true);
                        }
                    }
                }
            }
        }
    }
    reApplyFormula(args) {
        const cellIdx = getRangeIndexes(args.isUnique ? this.uniqueColl : this.sortColl);
        const cell = getCell(cellIdx[0], cellIdx[1], this.parent.getActiveSheet());
        this.parent.updateCellInfo({ value: '' }, getRangeAddress([cellIdx[0], cellIdx[1]]), true);
        const sheets = this.parent.sheets;
        let formula = cell.formula;
        for (let i = 0; i < sheets.length; i++) {
            if (formula.indexOf(sheets[i].name) > -1) {
                formula = formula.replace(sheets[i].name, '!' + i);
            }
        }
        if (args.isUnique) {
            this.parent.notify(workbookFormulaOperation, { action: 'computeExpression', formula: formula });
            this.uniqueCell = false;
            if (this.uniqueActCell !== '') {
                this.editCellData.value = this.uniqueActCell;
                this.uniqueActCell = '';
            }
        }
        else {
            this.parent.notify(workbookFormulaOperation, { action: 'nestedFormulaTrue', formula: formula });
            this.sortCell = false;
            if (this.sortActCell !== '') {
                this.editCellData.value = this.sortActCell;
                this.sortActCell = '';
            }
        }
    }
    refreshDependentCellValue(rowIdx, colIdx) {
        if (rowIdx && colIdx) {
            rowIdx--;
            colIdx--;
            if (this.editCellData.rowIndex !== rowIdx || this.editCellData.colIndex !== colIdx || this.uniqueCell) {
                const sheet = this.parent.getActiveSheet();
                let td;
                if (!isHiddenRow(sheet, rowIdx) && !isHiddenCol(sheet, colIdx)) {
                    td = this.parent.getCell(rowIdx, colIdx);
                }
                if (td) {
                    const row = td.parentElement;
                    if (row) {
                        const curRowIdx = row.getAttribute('aria-rowindex');
                        if (curRowIdx && Number(curRowIdx) - 1 !== rowIdx) {
                            return;
                        }
                        const curColIdx = td.getAttribute('aria-colindex');
                        if (curColIdx && Number(curColIdx) - 1 !== colIdx) {
                            return;
                        }
                    }
                    const cell = getCell(rowIdx, colIdx, sheet);
                    const actCell = getRangeIndexes(sheet.activeCell);
                    if (actCell[0] === rowIdx && actCell[1] === colIdx) {
                        this.uniqueActCell = cell.value;
                    }
                    const eventArgs = this.getRefreshNodeArgs(cell, td, rowIdx, colIdx);
                    this.parent.refreshNode(td, eventArgs);
                }
            }
        }
    }
    getRefreshNodeArgs(cell, tdEle, rowIdx, colIdx) {
        cell = cell || {};
        const eventArgs = {
            value: cell.value, format: cell.format,
            formattedText: cell.formattedText && cell.formattedText !== '' ? cell.formattedText : cell.value, isRightAlign: false,
            type: 'General', cell: cell, rowIndex: rowIdx, td: tdEle, colIndex: colIdx, refresh: true, isEdit: true
        };
        this.parent.notify(getFormattedCellObject, eventArgs);
        return eventArgs;
    }
    endEdit(refreshFormulaBar = false, event, isPublic) {
        if (refreshFormulaBar) {
            this.refreshEditor(this.editCellData.oldValue, false, true, false, false);
        }
        const triggerEventArgs = this.triggerEvent('beforeCellSave');
        if (triggerEventArgs.cancel) {
            if (this.parent.isEdit && event) {
                event.preventDefault();
            }
            return;
        }
        if (!this.isAltEnter && triggerEventArgs.value && triggerEventArgs.value.toString().indexOf('\n') > -1) {
            const cell = getCell(this.editCellData.rowIndex, this.editCellData.colIndex, this.parent.getActiveSheet());
            wrapText(this.parent.getActiveSheet().activeCell, cell ? (cell.wrap === false ? false : true) :
                true, this.parent);
            this.refreshEditor(triggerEventArgs.value, this.isCellEdit, false, false, false);
        }
        this.updateEditedValue(true, triggerEventArgs.value, event, isPublic);
    }
    cancelEdit(refreshFormulaBar = true, trigEvent = true, event, isInternal) {
        this.refreshEditor(this.editCellData.oldValue, refreshFormulaBar, false, false, false);
        if (!isInternal) {
            if (trigEvent) {
                this.triggerEvent('cellSave', event, undefined, true);
            }
            else {
                this.triggerEvent('cellEdited');
            }
        }
        this.resetEditState();
        this.focusElement();
    }
    focusElement(e) {
        if (e && e.keyCode === 9 && document.activeElement.classList.contains('e-formula-bar')) {
            const focusEle = this.parent.element.querySelector(`.e-formula-bar-panel ${e.shiftKey ? '.e-insert-function' : '.e-combobox'}`);
            if (focusEle) {
                focus(focusEle);
            }
        }
        else {
            focus(this.parent.element);
        }
        this.parent.notify(enableToolbarItems, [{ enable: true }]);
    }
    triggerEvent(eventName, event, value, pvtManualCalc) {
        const sheet = this.parent.getActiveSheet();
        let cell = getCell(this.editCellData.rowIndex, this.editCellData.colIndex, sheet);
        const eventArgs = {
            element: this.editCellData.element,
            value: value ? value : this.editCellData.value,
            oldValue: this.editCellData.oldValue,
            address: this.editCellData.fullAddr,
            displayText: this.parent.getDisplayText(cell),
            previousFormulaValue: this.editCellData.prevFormulaValue
        };
        if (eventArgs.address) {
            const indexes = getRangeIndexes(eventArgs.address);
            const uniqueArgs = { cellIdx: indexes, isUnique: false };
            this.checkUniqueRange(uniqueArgs);
            if (uniqueArgs.isUnique) {
                eventArgs.isSpill = this.isSpill;
            }
            const sortArgs = { cellIdx: indexes, isSort: false };
            this.checkSortRange(sortArgs);
            if (sortArgs.isSort) {
                eventArgs.isSpill = this.isSpill;
            }
        }
        const isValueChanged = (eventArgs.value || eventArgs.value === 0 ? eventArgs.value.toString() : '') !==
            (eventArgs.oldValue || eventArgs.oldValue === 0 ? eventArgs.oldValue.toString() : '');
        if (isValueChanged || (!pvtManualCalc && checkIsFormula(eventArgs.value) && (!cell || !cell.format ||
            getTypeFromFormat(cell.format) !== 'Text'))) {
            if (eventName !== 'cellSave') {
                eventArgs.cancel = false;
            }
            if (eventName === 'beforeCellSave') {
                this.parent.notify(beginAction, { eventArgs: eventArgs, action: 'cellSave', preventAction: true });
                cell = checkIsFormula(eventArgs.value) ? { formula: eventArgs.value } : { value: eventArgs.value };
                const cancel = updateCell(this.parent, sheet, { cell: cell, rowIdx: this.editCellData.rowIndex, colIdx: this.editCellData.colIndex,
                    eventOnly: true });
                if (cancel) {
                    this.cancelEdit(false, false, null, true);
                    eventArgs.cancel = true;
                    return eventArgs;
                }
            }
            this.parent.trigger(eventName, eventArgs);
            if (eventName === 'cellSave') {
                this.parent.trigger('cellEdited', eventArgs);
                if (this.editCellData.formula) {
                    eventArgs.formula = this.editCellData.formula;
                }
                else if (!isValueChanged) {
                    eventArgs.formula = eventArgs.value;
                }
                if (cell.format) {
                    eventArgs.format = cell.format;
                }
                eventArgs.originalEvent = event;
                this.parent.notify(completeAction, { eventArgs: eventArgs, action: 'cellSave' });
            }
        }
        else if (eventName !== 'beforeCellSave') {
            if (eventName === 'cellSave') {
                this.parent.trigger('cellEdited', eventArgs);
            }
            else {
                this.parent.trigger(eventName, eventArgs);
            }
        }
        return eventArgs;
    }
    altEnter() {
        this.positionEditor(true);
        const selection = window.getSelection();
        const node = selection.anchorNode;
        let offset;
        let range = document.createRange();
        offset = (node.nodeType === 3) ? selection.anchorOffset : node.textContent.length;
        if (offset === 0 && node.textContent.length > 0) {
            offset = node.textContent.length;
        }
        const text = node.textContent;
        const textBefore = text.slice(0, offset);
        const textAfter = text.slice(offset) || ' ';
        node.textContent = textBefore + '\n' + textAfter;
        range = document.createRange();
        if (node.nodeType === 3) {
            range.setStart(node, offset + 1);
            range.setEnd(node, offset + 1);
        }
        else if (node.nodeType === 1) {
            range.setStart(node.firstChild, offset + 1);
            range.setEnd(node.firstChild, offset + 1);
        }
        selection.removeAllRanges();
        selection.addRange(range);
    }
    resetEditState(elemRefresh = true) {
        const editorElem = this.getEditElement(this.parent.getActiveSheet());
        if (elemRefresh) {
            if (checkIsFormula(editorElem.textContent, this.isEdit) || editorElem.textContent === '') {
                this.parent.notify(clearCellRef, null);
            }
            if (this.editCellData.element) {
                this.editCellData.element.classList.remove('e-ss-edited');
                this.editorElem.textContent = '';
                if (editorElem === this.editorElem) {
                    this.editorElem.removeAttribute('style');
                    this.editorElem.classList.remove('e-right-align');
                }
                else {
                    detach(editorElem);
                }
            }
        }
        this.editCellData = {};
        this.parent.isEdit = this.isEdit = false;
        this.isCellEdit = true;
        this.isAltEnter = false;
        this.parent.notify(formulaOperation, { action: 'endEdit' });
        if (Browser.isDevice && Browser.info.name === 'safari' && (Browser.isIos || Browser.isIos7)) {
            EventHandler.remove(editorElem, 'paste', this.pasteHandler);
        }
        if (this.parent.showSheetTabs && !this.parent.isProtected) {
            const addSheetBtn = this.parent.element.querySelector('.e-add-sheet-tab');
            if (addSheetBtn) {
                addSheetBtn.removeAttribute('disabled');
            }
        }
    }
    refSelectionRender() {
        let editorElem = this.getEditElement(this.parent.getActiveSheet());
        if (editorElem) {
            if (checkIsFormula(editorElem.textContent)) {
                this.parent.notify(initiateFormulaReference, {
                    range: editorElem.textContent, formulaSheetIdx: this.editCellData.sheetIndex
                });
            }
            editorElem = this.parent.getCell(this.editCellData.rowIndex, this.editCellData.colIndex);
            if (editorElem) {
                this.editCellData.element = editorElem;
            }
        }
    }
    // Start edit the formula cell and set cursor position
    initiateRefSelection() {
        const sheetName = this.editCellData.fullAddr.substring(0, this.editCellData.fullAddr.lastIndexOf('!'));
        const value = this.editCellData.value;
        if (this.parent.getActiveSheet().name === sheetName && checkIsFormula(this.editCellData.value, true)) {
            this.startEdit(this.editCellData.addr, value, false);
            this.parent.notify(initiateFormulaReference, {
                range: this.editCellData.value, formulaSheetIdx: this.editCellData.sheetIndex
            });
            this.getEditElement(this.parent.getActiveSheet()).textContent = value;
            this.initiateCurPosition();
        }
        else {
            this.initiateCurPosition();
        }
    }
    addressHandler(args) {
        const dlgInst = this.parent.serviceLocator.getService(dialog).dialogInstance;
        if (dlgInst && dlgInst.element && dlgInst.element.classList.contains('e-validation-error-dlg')) {
            args.isAlertDlgOpen = true;
            return;
        }
        if (!this.curStartPos) {
            const curOffset = this.getCurPosition();
            if (curOffset.start) {
                this.curStartPos = curOffset.start;
            }
            if (curOffset.end) {
                this.curEndPos = curOffset.end;
            }
        }
        let address = args.range;
        let sheetIdx = this.editCellData.sheetIndex;
        const editorEle = this.getEditElement(this.parent.getActiveSheet());
        address = this.getMergedAddress(address);
        if (this.parent.activeSheetIndex !== sheetIdx) {
            address = '\'' + this.parent.getActiveSheet().name + '\'' + '!' + address;
            if (args.isNameBoxSelect) {
                sheetIdx = this.parent.activeSheetIndex;
            }
        }
        const editedValue = this.editCellData.value;
        if (args.isSelect) {
            this.parent.notify(initiateFormulaReference, { range: editedValue + address, formulaSheetIdx: sheetIdx });
        }
        else if (this.parent.activeSheetIndex === sheetIdx) {
            const editorContent = document.activeElement.classList.contains('e-formula-bar') ?
                document.activeElement.value : editorEle.textContent;
            if (args.isNameBoxSelect && this.parent.isEdit) {
                this.parent.notify(initiateFormulaReference, { range: editedValue + address, formulaSheetIdx: sheetIdx });
                this.curStartPos = editedValue.length;
            }
            let startVal;
            let endVal;
            if (args.isMouseDown && editorContent !== editedValue) {
                startVal = editorContent.substring(0, this.curEndPos) + this.parent.listSeparator;
                endVal = editorContent.substring(this.curEndPos);
                this.refreshEditor(startVal + endVal, false, true);
                this.parent.notify(initiateFormulaReference, { range: editorEle.textContent, formulaSheetIdx: sheetIdx });
                this.curEndPos += this.parent.listSeparator.length;
                this.curStartPos = this.curEndPos;
                startVal += address;
            }
            else {
                startVal = editedValue.substring(0, this.curStartPos) + address;
                endVal = editedValue.substring(this.curStartPos);
                if (args.isNameBoxSelect) {
                    this.refreshEditor(startVal + endVal, true, true);
                }
            }
            editorEle.textContent = startVal + endVal;
            this.curEndPos = startVal.length;
        }
    }
    updateFormulaBarValue(args) {
        const value = this.editCellData.value;
        const lastRange = this.parent.getActiveSheet().selectedRange.split(' ');
        let address = lastRange[lastRange.length - 1];
        address = isSingleCell(getIndexesFromAddress(address)) ? address.split(':')[0] :
            getRangeAddress(getSwapRange(getRangeIndexes(address)));
        address = this.getMergedAddress(address);
        const formulaBar = this.parent.element.querySelector('.e-formula-bar');
        if (value && checkIsFormula(value, true)) {
            const sheetName = this.editCellData.fullAddr.substring(0, this.editCellData.fullAddr.lastIndexOf('!'));
            const otherSheet = this.parent.getActiveSheet().name !== sheetName;
            if (otherSheet) {
                address = '\'' + this.parent.getActiveSheet().name + '\'' + '!' + address;
            }
            let startVal;
            let endVal;
            if (otherSheet && args.isMouseDown && lastRange.length > 1 && args.formulaBarVal && args.formulaBarVal !== value) {
                startVal = args.formulaBarVal.substring(0, this.curEndPos) + this.parent.listSeparator;
                endVal = args.formulaBarVal.substring(this.curEndPos);
                this.refreshEditor(startVal + endVal, true);
                this.curEndPos += this.parent.listSeparator.length;
                this.curStartPos = this.curEndPos;
                startVal += address;
            }
            else {
                startVal = value.substring(0, this.curStartPos) + address;
                endVal = value.substring(this.curStartPos);
            }
            formulaBar.value = startVal + endVal;
            this.curEndPos = startVal.length;
        }
    }
    getMergedAddress(address) {
        const rangeIndex = getRangeIndexes(address);
        if (rangeIndex[0] !== rangeIndex[2] || rangeIndex[1] !== rangeIndex[3]) {
            const cellModel = getCell(rangeIndex[0], rangeIndex[1], this.parent.getActiveSheet());
            if (cellModel && (cellModel.rowSpan || cellModel.colSpan)) {
                const mergeArgs = { range: [rangeIndex[0], rangeIndex[1], rangeIndex[0], rangeIndex[1]] };
                this.parent.notify(mergedRange, mergeArgs);
                const mergedRanges = mergeArgs.range;
                if (rangeIndex[0] === mergedRanges[0] && rangeIndex[1] === mergedRanges[1] &&
                    rangeIndex[2] === mergedRanges[2] && rangeIndex[3] === mergedRanges[3]) {
                    return getCellAddress(mergedRanges[0], mergedRanges[1]);
                }
            }
        }
        return address;
    }
    setFormulaBarCurPosition(input, selectionStart, selectionEnd) {
        if (input.setSelectionRange) {
            input.focus();
            input.selectionStart = selectionStart;
            input.selectionEnd = selectionStart;
            input.setSelectionRange(selectionStart, selectionEnd);
        }
    }
    initiateCurPosition(args = { isCellEdit: false }) {
        const el = this.getEditElement(this.parent.getActiveSheet(), true);
        if (args.isCellEdit) {
            const curOffset = this.getCurPosition();
            if (!this.endFormulaRef && curOffset.start === curOffset.end) {
                this.updateFormulaReference(el);
                const validCharacters = ['+', '-', '*', '/', this.parent.listSeparator, '(', '=', '&', ':'];
                if (curOffset.end && validCharacters.indexOf(this.editCellData.value[curOffset.end - 1]) === -1) {
                    this.endFormulaRef = true;
                }
            }
            return;
        }
        const value = el.innerText;
        const selection = window.getSelection();
        if ((selection && selection.focusNode && selection.focusNode.classList &&
            selection.focusNode.classList.contains('e-formula-bar-panel'))) {
            const formulaBar = this.parent.element.querySelector('.e-formula-bar');
            this.setFormulaBarCurPosition(formulaBar, this.curEndPos, this.curEndPos);
            return;
        }
        if (value) {
            const range = document.createRange();
            if (value.indexOf(')') === value.length - 1) {
                range.setStart(el.childNodes[0], this.curEndPos);
                range.setEnd(el.childNodes[0], this.curEndPos);
            }
            else {
                range.setStart(el.childNodes[0], this.curEndPos);
                range.setEnd(el.childNodes[0], this.curEndPos);
            }
            selection.removeAllRanges();
            selection.addRange(range);
        }
        const sheetIdx = this.editCellData.sheetIndex;
        if (sheetIdx !== this.parent.activeSheetIndex) {
            const elem = this.parent.element.querySelector('.e-formula-bar');
            if (elem && elem.value) {
                if (elem.value.indexOf(')') === this.curEndPos - 1) {
                    this.setFormulaBarCurPosition(elem, this.curEndPos - 1, this.curEndPos - 1);
                }
                else {
                    this.setFormulaBarCurPosition(elem, this.curEndPos, this.curEndPos);
                }
            }
        }
    }
    getEditElement(sheet, isEdit) {
        if ((this.isEdit || isEdit) && (sheet.frozenRows || sheet.frozenColumns)) {
            const frozenRow = this.parent.frozenRowCount(sheet);
            const frozenCol = this.parent.frozenColCount(sheet);
            const range = getCellIndexes(sheet.activeCell);
            let content;
            if (range[0] < frozenRow && range[1] < frozenCol) {
                content = this.parent.getSelectAllContent();
            }
            else if (range[0] < frozenRow) {
                content = this.parent.getColumnHeaderContent();
            }
            else if (range[1] < frozenCol) {
                content = this.parent.getRowHeaderContent();
            }
            else {
                return this.editorElem;
            }
            let editEle = content.getElementsByClassName('e-spreadsheet-edit')[0];
            if (!editEle && isEdit) {
                editEle = content.appendChild(this.editorElem.cloneNode());
            }
            return editEle;
        }
        return this.editorElem;
    }
    sheetChangeHandler() {
        if (!this.isEdit) {
            this.editCellData.value = null;
        }
    }
    showFormulaAlertDlg(errorString, triggerBeforeOpenEvt) {
        const l10n = this.parent.serviceLocator.getService(locale);
        const alertDialog = this.parent.serviceLocator.getService('dialog');
        let cursorPosition;
        const errorKey = this.getFormulaErrorKey(errorString);
        let cancel;
        const content = l10n.getConstant(errorKey);
        const dlgInst = alertDialog.dialogInstance;
        if (dlgInst && dlgInst.visible && dlgInst.element.classList.contains('e-circularref-dlg')) {
            return cancel;
        }
        alertDialog.show({
            width: 400, isModal: true, showCloseIcon: true, target: this.parent.element, cssClass: 'e-validation-error-dlg e-circularref-dlg',
            content: content,
            beforeOpen: (args) => {
                if (triggerBeforeOpenEvt) {
                    const sheet = this.parent.getActiveSheet();
                    const dlgArgs = { dialogName: 'CircularReferenceDialog', element: args.element,
                        target: args.target, cancel: args.cancel, cellAddress: `${sheet.name}!${sheet.activeCell}`, content: content };
                    this.parent.trigger('dialogBeforeOpen', dlgArgs);
                    if (dlgArgs.cancel) {
                        args.cancel = cancel = true;
                        return;
                    }
                    else if (dlgArgs.content !== content) {
                        alertDialog.dialogInstance.content = dlgArgs.content;
                        alertDialog.dialogInstance.dataBind();
                    }
                }
                if (window.getSelection().rangeCount > 0) {
                    const range = window.getSelection().getRangeAt(0);
                    cursorPosition = range.endOffset;
                }
            },
            buttons: [{
                    buttonModel: { content: l10n.getConstant('Ok'), isPrimary: true },
                    click: () => alertDialog.hide()
                }],
            close: () => {
                if (!cancel) {
                    const elem = this.getEditElement(this.parent.getActiveSheet());
                    if (elem.childElementCount) {
                        const textContent = elem.textContent;
                        cursorPosition = textContent.length;
                        elem.textContent = textContent;
                    }
                    const selection = document.getSelection();
                    const range = document.createRange();
                    range.setStart(elem.firstChild, cursorPosition);
                    range.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    elem.focus();
                }
            }
        }, false);
        return cancel;
    }
    getFormulaErrorKey(errorString) {
        let errorKey;
        switch (errorString) {
            case 'invalid arguments':
                errorKey = 'InvalidArguments';
                break;
            case 'improper formula':
                errorKey = 'ImproperFormula';
                break;
            case 'empty expression':
                errorKey = 'EmptyExpression';
                break;
            case 'mismatched parentheses':
                errorKey = 'MismatchedParenthesis';
                break;
            case 'mismatched string quotes':
                errorKey = 'MismatchedStringQuotes';
                break;
            case 'wrong number of arguments':
                errorKey = 'WrongNumberOfArguments';
                break;
            case 'requires 3 arguments':
                errorKey = 'Requires3Arguments';
                break;
            case '#CIRCULARREF!':
                errorKey = 'FormulaCircularRef';
                break;
            default:
                errorKey = 'InvalidFormulaError';
        }
        return errorKey;
    }
    readOnlyAlertHandler() {
        const l10n = this.parent.serviceLocator.getService(locale);
        const dialog = this.parent.serviceLocator.getService('dialog');
        const findDialog = this.parent.element.querySelector('.e-find-dlg');
        let findDlgInst;
        if (!isNullOrUndefined(findDialog)) {
            findDlgInst = getComponent(findDialog, 'dialog');
        }
        dialog.show({
            content: l10n.getConstant('ReadonlyAlert'),
            isModal: true,
            closeOnEscape: true,
            showCloseIcon: true,
            width: '400px',
            cssClass: 'e-readonly-alert-dlg',
            beforeOpen: (args) => {
                const dlgArgs = {
                    dialogName: 'ReadOnlyAlertDialog',
                    content: l10n.getConstant('ReadonlyAlert'),
                    element: args.element, target: args.target, cancel: args.cancel
                };
                this.parent.trigger('dialogBeforeOpen', dlgArgs);
                if (dlgArgs.cancel) {
                    args.cancel = true;
                }
                else {
                    dialog.dialogInstance.content = dlgArgs.content;
                    focus(this.parent.element);
                }
            },
            close: () => {
                if (!isNullOrUndefined(findDialog)) {
                    dialog.dialogInstance = findDlgInst;
                }
                focus(this.parent.element);
            }
        });
    }
    removeRefIndicator() {
        const formulaRefIndicator = this.parent.element.querySelector('.e-formularef-indicator');
        if (formulaRefIndicator) {
            formulaRefIndicator.parentElement.removeChild(formulaRefIndicator);
        }
    }
    finiteAlertHandler() {
        const l10n = this.parent.serviceLocator.getService(locale);
        const dialog = this.parent.serviceLocator.getService('dialog');
        dialog.show({
            header: l10n.getConstant('Alert'),
            content: l10n.getConstant('FiniteAlert'),
            isModal: true,
            closeOnEscape: true,
            showCloseIcon: true,
            width: '400px',
            cssClass: 'e-finite-alert-dlg'
        });
    }
}
